import antdIt from "antd/locale/it_IT";
import itMessages from "../locales/it_IT.json";

const itLang = {
  messages: {
    ...itMessages
  },
  antd: antdIt,
  locale: 'it'
};
export default itLang;
